<template>
  <div>
    <div v-if="eyebrowText" v-style:c="eyebrowTextColor" class="uppercase">
      {{ eyebrowText }}
    </div>
    <cms-base-responsive-media
      v-if="eyebrowLogoResponsive"
      class-name="h-full"
      fit="contain"
      :media="eyebrowLogoResponsive"
      :props-img="{ class: 'max-h-24 object-left' }"
    />
  </div>
</template>

<script setup lang="ts">
import type { StyledEyebrow } from '#types/styles'

defineProps<StyledEyebrow>()
</script>
